import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { ElementDataType } from './types';

import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import React from 'react';
import { shallow } from 'zustand/shallow';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { Input } from '@/components/ui/input';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const handleAutoplayChange = (val: boolean) => {
    builder.setElementData(element.id, {
      autoplay: val,
      mute: val ? true : content.mute,
    });
  };

  const handleMuteChange = (val: boolean) => {
    if (!val) {
      builder.setElementData(element.id, {
        autoplay: false,
        mute: val,
      });
    } else {
      builder.setElementData(element.id, {
        mute: val,
      });
    }
  };

  const content = element.data as ElementDataType;
  return (
    <div>
      <div className='mt-6 flex items-center justify-between space-x-2'>
        <Label htmlFor='isYoutubeVideo'>Youtube Video</Label>
        <Switch
          id='isYoutubeVideo'
          checked={content.isYoutubeVideo}
          onCheckedChange={(val) => {
            builder.setElementData(element.id, {
              isYoutubeVideo: val,
            });
          }}
        />
      </div>
      {!content.isYoutubeVideo ? (
        <>
          <div className='mb-3'>Video url</div>
          <Input
            onChange={(e) =>
              builder.setElementData(element.id, {
                video: e.target.value,
              })
            }
            name='video'
            type='text'
            size={100}
            defaultValue={content.video}
            value={content.video}
            className='mb-2 w-full'
            placeholder='https://'
          />
          <div className='mb-4'>Supported formats: .mp4, .webm, .ogv</div>
          <div className='mb-2'>Mobile video url (optional)</div>
          <Input
            onChange={(e) =>
              builder.setElementData(element.id, {
                mobileVideo: e.target.value,
              })
            }
            name='mobileVideo'
            type='text'
            size={100}
            value={content.mobileVideo}
            className='mb-2 w-full'
            placeholder='https://'
          />
          <div className='mb-4'>Supported formats: .mp4, .webm, .ogv</div>
        </>
      ) : (
        <>
          <div className='mb-3'>Youtube Video url</div>
          <Input
            onChange={(e) =>
              builder.setElementData(element.id, {
                youtubeVideoUrl: e.target.value,
              })
            }
            name='youtubeVideoUrl'
            type='text'
            size={100}
            value={content.youtubeVideoUrl}
            className='mb-2 w-full'
            placeholder='https://'
          />
          <div className='mb-4'>Supported formats: .mp4, .webm, .ogv</div>
          <div className='mb-2'>Youtube Mobile video url (optional)</div>
          <Input
            onChange={(e) =>
              builder.setElementData(element.id, {
                youtubeMobileVideo: e.target.value,
              })
            }
            name='youtubeMobileVideo'
            type='text'
            size={100}
            value={content.youtubeMobileVideo}
            className='mb-2 w-full'
            placeholder='https://'
          />
          <div className='mb-4'>Supported formats: .mp4, .webm, .ogv</div>
        </>
      )}

      <InputSlider
        label='Device under this size use mobile video'
        value={content.mobileMinWidth || 0}
        max={1440}
        min={0}
        rightContent={<div>px</div>}
        onChange={(val) =>
          builder.setElementData(element.id, {
            mobileMinWidth: val,
          })
        }
      />
      <div className='mb-2 mt-4 text-sm'>Layout</div>
      <InputTab
        grid={2}
        defaultValue={content.layout}
        options={[
          { label: 'Full Width', value: 'full' },
          { label: 'Grid', value: 'grid' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { layout: v })}
      />
      {!content.isYoutubeVideo && (
        <>
          <div className='mt-6 flex items-center justify-between space-x-2'>
            <Label htmlFor='autoplay'>Autoplays</Label>
            <Switch
              id='autoplay'
              checked={content.autoplay}
              onCheckedChange={handleAutoplayChange}
            />
          </div>
          <div className='mt-4 flex items-center justify-between space-x-2'>
            <Label htmlFor='loop'>Plays in a loop</Label>
            <Switch
              id='loop'
              checked={content.loop}
              onCheckedChange={(val) => {
                builder.setElementData(element.id, {
                  loop: val,
                });
              }}
            />
          </div>
          <div className='mt-4 flex items-center justify-between space-x-2'>
            <Label htmlFor='loop'>Controls</Label>
            <Switch
              id='controls'
              checked={content.controls}
              onCheckedChange={(val) => {
                builder.setElementData(element.id, {
                  controls: val,
                });
              }}
              disabled={content.autoplay === true}
            />
          </div>
          <div className='mt-4 flex items-center justify-between space-x-2'>
            <Label htmlFor='loop'>Mute</Label>
            <Switch id='mute' checked={content.mute} onCheckedChange={handleMuteChange} />
          </div>
        </>
      )}
      <PaddingSetting
        value={content.padding}
        onChange={(v) =>
          builder.setElementData(element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}
